import React from 'react';
import { autobind } from 'core-decorators';
import Layout from '../components/Layout/LayoutIndex';
import { getHtmlTDK, getVal } from '../../../lib/utils/UtilsCommon';
import CourseTab from './components/course-tab/index';

import './MoreCourses.less';

/**
 * state
 */
interface IState {
	htmlTDK: {
		title: string;
	};
}

/**
 * MoreCourses page
 *
 * @class MoreCourses
 * @extends {React.Component<any>}
 */
@autobind
class MoreCourses extends React.Component<any, any> {
	private mediaPlayer: any = null;

	constructor(props: any, context?: any) {
		super(props, context);
		let { initData } = props;
		const state: any = {
			htmlTDK: {
				title: '学兴趣就上兴趣岛——名师更多，课程更全',
				pageDescription:
					'兴趣岛兴趣学堂-名师更多，课程更全。摄影、瑜伽等30门主流课程21门学员数量全国领先。',
				pageKeyword:
					'兴趣,兴趣岛,兴趣岛兴趣学堂,兴趣学堂,千聊兴趣岛,兴趣岛-名师更多，课程更全,兴趣岛兴趣学堂-名师更多，课程更全,千聊,知识付费,内容付费,千聊特训营,成人教育',
			},
		};

		this.state = state;
	}

	/**
	 * 动态渲染数据放这里处理
	 *
	 * @static
	 * @param {*} { req }
	 * @returns {Promise<any>}
	 */
	public static async getInitialProps(context: any): Promise<any> {
		const { query, params } = context.req;
		let initData: any = {
			...params,
		};

		return {
			query,
			initData,
			sysTime: Date.now(),
		};
	}

	/**
	 * 客户端调用获取数据
	 *
	 * @memberof MoreCourses
	 */
	public async componentDidMount(): Promise<any> {
		this.initWowScript();

		return {};
	}

	/**
	 * 初始化
	 */
	public async initWowScript(): Promise<any> {
		await this.createScript(
			'https://media.qlchat.com/qlLive/activity/file/QBKBO41J-RLCI-MOVV-1630580445604-X24XZHO7JSF3.js',
		);
		if (!/msie [6|7|8|9]/i.test(navigator.userAgent)) {
			return await new (window as any).WOW().init();
		}
	}

	/**
	 * 创建
	 */
	public createScript(src: string): any {
		return new Promise((resolve, reject): any => {
			const script: any = document.createElement('script');
			script.src = src;
			script.onload = (): any => {
				resolve(true);
			};
			document.body.appendChild(script);
		});
	}
	/**
	 * 渲染页面
	 *
	 * @returns {*}
	 * @memberof MoreCourses
	 */
	public render(): any {
		const { htmlTDK } = this.state;

		return (
			<Layout {...getHtmlTDK(htmlTDK)} bodyClass="more-course-page" activeTab="more-course">
				<div className="main-container">
					<div className="course-container">
						<div className="main-container-width">
							<div className="column-title wow fadeInUp" id="topic">
								<img
									className="column-title-img"
									src="https://img.qlchat.com/qlLive/activity/image/J7JMDTS5-5UOB-91QS-1709637586595-PIW2M8V2TSYP.png?x-oss-process=image/format,webp"
								/>
								<div className="column-title-desc">
									兴趣岛目前已开设摄影、瑜伽、太极、中医等30门主流课程，其中21门学员数量全国领先。
								</div>
							</div>
							<CourseTab />
						</div>
					</div>
				</div>
			</Layout>
		);
	}
}

export default MoreCourses;
